import React from "react"
import { ExternalLink } from "components"

import styles from "./agendaItem.module.scss"

const AgendaItem = ({ content }) => {
  return (
    <div className={styles.agendaItem}>
      <div className={styles.agendaTime}>{content.time}</div>
      {content.overline && (
        <div className={styles.agendaOverline}>{content.overline}</div>
      )}
      <div className={styles.agendaDesc}>
        {content.url ? (
          <ExternalLink url={content.url}>{content.desc}</ExternalLink>
        ) : (
          content.desc
        )}{" "}
        {content.rsvp && (
          <ExternalLink className={styles.agendaBtn} url={content.rsvp}>
            <span>RSVP</span>
          </ExternalLink>
        )}
      </div>
      {content.about && (
        <div className={styles.agendaAbout}>{content.about}</div>
      )}
      {content.speakers && (
        <div className={styles.agendaSpeakerList}>
          Panelists:{" "}
          {content.speakers.map((speaker, i) => {
            return (
              <span key={i}>
                {speaker}
                {content.speakers.length < 2 ||
                content.speakers.length - 2 === i
                  ? " and "
                  : content.speakers.length - 1 !== i && ", "}
              </span>
            )
          })}
        </div>
      )}
      {content.moderator && (
        <div className={styles.moderator}>
          Moderated by:{" "}
          {content.moderator.url ? (
            <ExternalLink url={content.moderator.url}>
              {content.moderator.name}
            </ExternalLink>
          ) : (
            content.moderator.name
          )}
        </div>
      )}
    </div>
  )
}

export default AgendaItem
